import { ID, idDef } from "@kosmod/kit";
import { SecretID } from "./account";
import { GameID } from "./game";
import { s } from "@kosmod/pancake";

export type InvitationID = ID<'game-invitation'>;
export const InvitationID = s.ref<InvitationID>()(idDef);

export type Invitation = {
  id: InvitationID,

  addressedTo: string,

  game: GameID,
  secret: SecretID,
};

export const Invitation = s.o({
  id: InvitationID,

  addressedTo: s.str,

  game: GameID,
  secret: SecretID,
});


export type InvitationDescription = {
  id: InvitationID,
  addressedTo: string,

  game: GameID,
  gameName: string,

  encodedURL: string,
}
export const InvitationDescription = s.ref<InvitationDescription>()(s.o({
  id: InvitationID,
  addressedTo: s.str,

  game: GameID,
  gameName: s.str,

  encodedURL: s.str,
}))